import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; // Импортируем стили
import style from './style.module.scss';

interface NewsSkeletonProps {
  count: number;
}

export const NewsSkeleton = ({ count }: NewsSkeletonProps) => {
  return (
    <div className={style.analitics}>
      <div className={style.list}>
        {[...Array(count)].map((_, index) => (
          <div className={style.item} key={index}>
            <div className={style.left}>
              <Skeleton className={style.poster} width={506} height={332} /> {/* Скелетон для изображения */}
            </div>
            <div className={style.right}>
              <h1 className={style.title}>
                <Skeleton height={50} /> {/* Скелетон для заголовка */}
              </h1>
              <p className={style.description}>
                <Skeleton  count={5} /> {/* Скелетон для описания */}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
